module.exports = __webpack_public_path__ + "img/amex.d0dc5c47.svg";